<template>
  <v-cotainer>
    <h2>four-oh-three</h2>
    <p>Website says no. Sorry, not only are you not allowed to access this page, you are forbidden!</p>
  </v-cotainer>
</template>

<script>
export default {
  data: () => ({
    title: "Page not found"
  })
};
</script>
